'use strict';

import React, {Component, useState} from 'react';
import {BrowserRouter as Router, Link, Switch, Route, useRouteMatch} from 'react-router-dom';

import auth from '../shared/auth';
import {cssClasses} from '../shared/utils';

import Dashboard from '../pages/dashboard';
import Browsers from '../pages/browsers';
import {MinutesChart, CCUChart, StreamsChart} from '../pages/charts';
import ServiceConfigurationPage from "../pages/service-config";

class ControllerWrapper extends Component {
	constructor(props) {
		super(props);
		this.c = null;
		this.el = null;
		this.state = {};
	}

	static initController() {
		throw new Error('NOT IMPLEMENTED');
	}

	async componentDidMount() {
		let c = this.constructor.initController();
		await c.render({container: this.el});
		this.c = c;
	}

	componentWillUnmount() {
		if (this.c) {
			this.c.destroy();
		}
	}

	render() {
		return <div ref={el => this.el = el}/>;
	}

	static wrap(Controller) {
		class WrappedController extends this {
			static initController() {
				return new Controller();
			}
		}

		return <WrappedController/>
	}
}

function TopLevelLink({to, children, setActive}) {
	let match = useRouteMatch({path: to, exact: true});
	if (match) {
		setActive();
	}
	return (
		<li role="navigation" className={cssClasses({active: match})}>
			<Link to={to}>{children}</Link>
		</li>
	);
}

function DropDownLink({to, children, setActive}) {
	let match = useRouteMatch({path: to, exact: true});
	if (match && setActive) {
		setActive();
	}
	return <li role="navigation" className={cssClasses({active: match})}><Link to={to}>{children}</Link></li>;
}

function DropDown({label, active, children}) {
	return (
		<li role="presentation" className={cssClasses('dropdown', {active})}>
			<a className="dropdown-toggle" data-toggle="dropdown" href="#" role="button">
				{label} <span className="caret"/>
			</a>
			<ul className="dropdown-menu">
				{children}
			</ul>
		</li>
	);
}

function PanelRouter() {
	let [active, setActive] = useState('dashboard');
	let setDashboard = setActive.bind(null, 'dashboard');
	let setKPI = setActive.bind(null, 'kpi');
	let setCharts = setActive.bind(null, 'charts');

	return (
		<Router>
			<ul className="nav nav-pills" id="cm-navigation">
				<TopLevelLink to="/" setActive={setDashboard}>Dashboard</TopLevelLink>
				<DropDown label="KPI" active={active === 'kpi'}>
					<DropDownLink to="/browsers" setActive={setKPI}>Browser stats</DropDownLink>
				</DropDown>
				<DropDown label="Charts" active={active === 'charts'}>
					<DropDownLink to="/charts-minutes" setActive={setCharts}>Minutes</DropDownLink>
					<DropDownLink to="/charts-streams" setActive={setCharts}>Streams</DropDownLink>
					<DropDownLink to="/charts-ccu" setActive={setCharts}>CCU</DropDownLink>
				</DropDown>
				<li role="presentation">
					<a className="dropdown-toggle" data-toggle="dropdown" href="#" role="button">
						<i className="fa fa-gears"/>
					</a>
					<ul className="dropdown-menu">
						<DropDownLink to="/service-configuration">Service configuration</DropDownLink>
						<li role="navigation">
							<a href="#" onClick={
								(e) => {
									e.stopPropagation();
									e.preventDefault();
									auth.signOut();
								}
							}>Sign out</a></li>
					</ul>
				</li>
			</ul>

			<section id="cm-page">
				<Switch>
					<Route path="/browsers">{ControllerWrapper.wrap(Browsers)}</Route>
					<Route path="/charts-minutes">{ControllerWrapper.wrap(MinutesChart)}</Route>
					<Route path="/charts-streams">{ControllerWrapper.wrap(StreamsChart)}</Route>
					<Route path="/charts-ccu">{ControllerWrapper.wrap(CCUChart)}</Route>
					<Route path="/service-configuration"><ServiceConfigurationPage/></Route>
					<Route path="/" exact>{ControllerWrapper.wrap(Dashboard)}</Route>
				</Switch>
			</section>
		</Router>
	);
}

export default PanelRouter;